import React from 'react'
import { LeftHomeButton } from './LeftHomeButton'
import { LeftReloadButton } from './LeftReloadButton'

type LeftButtonProps = {
	showReloadButton: boolean
	showHomeButton: boolean
}

export const LeftButton = ({
	showReloadButton,
	showHomeButton,
}: LeftButtonProps) => {
	if (showReloadButton) {
		return <LeftReloadButton />
	}
	return showHomeButton ? <LeftHomeButton /> : null
}
